import { render, staticRenderFns } from "./RepairPlanUpdatesPage.vue?vue&type=template&id=fcf59440&"
import script from "./RepairPlanUpdatesPage.vue?vue&type=script&lang=ts&"
export * from "./RepairPlanUpdatesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports